import { render, staticRenderFns } from "./WritingsUnassignedOrInProgressTable.vue?vue&type=template&id=527facbd&scoped=true&"
import script from "./WritingsUnassignedOrInProgressTable.vue?vue&type=script&lang=js&"
export * from "./WritingsUnassignedOrInProgressTable.vue?vue&type=script&lang=js&"
import style0 from "./WritingsUnassignedOrInProgressTable.vue?vue&type=style&index=0&id=527facbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527facbd",
  null
  
)

export default component.exports